export default __webpack_public_path__ + "static/media/09.8ecfa5d6.jpg";